export const resolveCategoryCreateMutationOutcome = ({
  responseOk = false,
  data = null,
  parentName = '',
} = {}) => {
  if (!responseOk) {
    return {
      success: false,
      outcome: 'category_create_failed',
      errorMessage: data?.error || 'Failed to create category',
      createdCategory: null,
    };
  }

  return {
    success: true,
    outcome: 'category_created',
    errorMessage: null,
    createdCategory: data?.category
      ? {
          ...data.category,
          parentName,
        }
      : null,
  };
};

export const resolveCategorySaveMutationOutcome = ({
  responseOk = false,
  data = null,
} = {}) => ({
  success: responseOk,
  outcome: responseOk ? 'category_saved' : 'category_save_failed',
  errorMessage: responseOk ? null : (data?.error || 'Could not save category'),
});

export const resolveCategoryDeleteMutationOutcome = ({
  responseOk = false,
  data = null,
} = {}) => ({
  success: responseOk,
  outcome: responseOk ? 'category_deleted' : 'category_delete_failed',
  errorMessage: responseOk ? null : (data?.error || 'Could not delete category'),
});

export const resolveBudgetSetupFlowOpenState = ({
  initialStep = 'selection',
} = {}) => ({
  showBudgetSetupModal: true,
  budgetSetupStep: initialStep,
});

export const resolveBudgetSetupFlowCloseState = () => ({
  showBudgetSetupModal: false,
});

export const resolveGlobalCategorizeFlowOpenState = ({
  returnContext = null,
} = {}) => ({
  showBudgetSetupModal: false,
  showGlobalCategorizeModal: true,
  globalCategorizeReturnContext: returnContext,
});

export const resolveGlobalCategorizeFlowCloseState = () => ({
  showGlobalCategorizeModal: false,
  globalCategorizeReturnContext: null,
});

export const resolveGlobalCategorizeBackToBudgetState = ({
  budgetSetupStep = 'selection',
} = {}) => ({
  showBudgetSetupModal: true,
  showGlobalCategorizeModal: false,
  globalCategorizeReturnContext: null,
  budgetSetupStep,
});

export const resolveBulkCategorizeCompletionState = ({
  result = null,
} = {}) => {
  const categorizedCount = Math.max(0, Number(result?.categorizedCount || 0));
  const rulesCreated = Math.max(0, Number(result?.rulesCreated || 0));

  return {
    categorizedCount,
    shouldReopenBudgetSetup: Boolean(result?.returnContext),
    toast: rulesCreated > 0
      ? {
          type: 'success',
          headline: 'Categories updated. We\'ll remember those merchants next time.',
          subheadline: `${categorizedCount} transactions updated`,
        }
      : {
          type: 'success',
          headline: `✅ Categorized ${categorizedCount} transactions`,
        },
  };
};

export const resolveBulkCategorizeCompletionFlowState = ({
  result = null,
  budgetSetupStep = 'selection',
} = {}) => {
  const completionState = resolveBulkCategorizeCompletionState({ result });

  return {
    ...completionState,
    modalState: completionState.shouldReopenBudgetSetup
      ? resolveGlobalCategorizeBackToBudgetState({ budgetSetupStep })
      : null,
  };
};
